import axios from "axios";
import { useEffect, useState } from "react";

const useAdmin = (user) => {
  const [admin, setAdmin] = useState("");

  useEffect(() => {
    const email = user?.email;
    (async () => {
      const { data } = await axios.get(
        `https://parts-master-server-five.vercel.app/admin/${email}`
      );
      setAdmin(data);
    })();
  }, [user]);

  return [admin];
};

export default useAdmin;
